import { v4 as uuidv4 } from "uuid";
import { WS_MESSAGE_TYPE } from "./webSocketType";

function send(socket, payload) {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false;
  try {
    socket.send(JSON.stringify(payload));
    return true;
  } catch (e) {
    console.warn("[chatWebSocket] send failed", e);
    return false;
  }
}

export function sendAuthRequest(socket, token) {
  send(socket, { type: WS_MESSAGE_TYPE.AUTH_REQUEST, payload: { token } });
}

export function sendTotalUnreadCountRequest(socket) {
  send(socket, { type: WS_MESSAGE_TYPE.USER_TOTAL_UNREAD_COUNT });
}

export function sendMessageHistoryRequest(
  socket,
  roomId,
  cursor = undefined,
  limit = 20,
  afterSeq = undefined
) {
  const payload = { roomId, limit };
  if (cursor != null && cursor !== "") payload.cursor = cursor;
  if (afterSeq != null && afterSeq > 0) payload.afterSeq = afterSeq;
  send(socket, { type: WS_MESSAGE_TYPE.MESSAGE_HISTORY, payload });
}

export function sendMessageSendRequest(
  socket,
  roomId,
  text = undefined,
  fileIds = undefined,
  requestId = uuidv4(),
  content = undefined
) {
  const payload = { roomId };
  if (text != null && text !== "") payload.text = text;
  if (Array.isArray(fileIds) && fileIds.length > 0) payload.fileIds = fileIds;
  if (content) payload.content = content;
  return send(socket, {
    type: WS_MESSAGE_TYPE.MESSAGE_SEND,
    payload,
    meta: { requestId },
  });
}

/** 서버 MarkRoomReadUpTo — lastReadSeq는 양수(message.messageSeq)만 유효 */
export function sendReadReceiptUpdate(socket, roomId, lastReadSeq, requestId = uuidv4()) {
  if (!roomId || typeof lastReadSeq !== "number" || lastReadSeq <= 0) return false;
  return send(socket, {
    type: WS_MESSAGE_TYPE.ROOM_READ_RECEIPT,
    payload: { roomId, lastReadSeq },
    meta: { requestId },
  });
}
